import * as R from 'remeda';
import { SchemaItem, SchemaSection } from '@rossum/api-client/schemas';
import { FieldsFormModel } from '../formModels';
import { adjustIds } from './toApiModel.adjusters';
import { backfillValues } from './toApiModel.backfills';
import { makeEvolver } from './toApiModel.evolvers';
import { stripEmpties } from './toApiModel.utils';

// TODO: Can we improve type safety here?
export const toApiModel = (
  originalItem: SchemaSection | SchemaItem | null,
  formModel: FieldsFormModel,
  addSuggest?: boolean
): SchemaItem | SchemaSection => {
  return R.pipe(
    formModel,
    R.prop('fieldType'),
    backfillValues(originalItem),
    R.evolve(makeEvolver(formModel)),
    adjustIds(originalItem),
    stripEmpties,
    obj => (addSuggest ? { ...obj, suggest: true } : obj)
    // TODO: Can we get rid of the cast?
  ) as SchemaItem | SchemaSection;
};
